export default "__VITE_ASSET__BpR8l4Dj__"